export default "__VITE_ASSET__Ctplox9m__"